import { Navigate } from 'react-router-dom'

export default function CallsIndex() {
  return <Navigate to="/calls/queue" replace />
}
